/* crst-cardsw.js — outlet-count switcher rendered as thumbnails overlaid on the product-card image
   (snippet crst-card-image). Delegated at document level so it covers every card surface
   (home .pcard rails, collection .pcardx grid, business .bpcard).

   - hover a thumb  -> swap the card's main image + price to that variant, mark it active
   - leave the group -> restore to the default (10-outlet) image, price, and active thumb
   - click a thumb  -> deep-link to the PDP with that variant preselected (?variant=)

   The thumbs are <span>s (valid inside the card's image <a>); the click handler cancels the
   anchor's navigation so the pill can route to its own ?variant URL instead. */
(function () {
  var CARD = '.pcard, .pcardx, .bpcard';
  var IMG = '.pcard-img img, .pcardx-img img, .bpcard-img img';
  var PRICE = '.pcard-price, .pcardx-price, .bpcard-price';

  function imgOf(c) { return c.querySelector(IMG); }
  function priceOf(c) { return c.querySelector(PRICE); }

  function setActive(grp, thumb) {
    grp.querySelectorAll('[data-cardsw-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  }

  function preview(thumb) {
    var card = thumb.closest(CARD); if (!card) return;
    var img = imgOf(card), price = priceOf(card), grp = thumb.closest('[data-cardsw]');
    if (img) {
      if (img.dataset.origSrc == null) {
        img.dataset.origSrc = img.getAttribute('src') || '';
        img.dataset.origSrcset = img.getAttribute('srcset') || '';
      }
      var u = thumb.getAttribute('data-img');
      /* a present srcset overrides src, so the swap is a no-op unless we drop srcset first */
      if (u) { img.removeAttribute('srcset'); img.setAttribute('src', u); }
    }
    if (price) {
      if (price.dataset.origHtml == null) price.dataset.origHtml = price.innerHTML;
      var p = thumb.getAttribute('data-price');
      if (p) price.textContent = p;
    }
    if (grp) setActive(grp, thumb);
  }

  function restore(grp) {
    var card = grp.closest(CARD); if (!card) return;
    var img = imgOf(card), price = priceOf(card);
    if (img && img.dataset.origSrc != null) {
      if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
      img.setAttribute('src', img.dataset.origSrc);
    }
    if (price && price.dataset.origHtml != null) price.innerHTML = price.dataset.origHtml;
    var def = grp.querySelector('[data-cardsw-default]') || grp.querySelector('[data-cardsw-thumb]');
    if (def) setActive(grp, def);
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest('[data-cardsw-thumb]');
    if (t) preview(t);
  });

  document.addEventListener('mouseout', function (e) {
    var t = e.target.closest('[data-cardsw-thumb]');
    if (!t) return;
    var grp = t.closest('[data-cardsw]');
    var to = e.relatedTarget;
    if (!to || !grp || !grp.contains(to)) restore(grp);
  });

  function activate(t) {
    var u = t.getAttribute('data-url');
    if (u) window.location.href = u;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cardsw-thumb]');
    if (!t) return;
    e.preventDefault();   // cancel the card image anchor's navigation
    e.stopPropagation();
    activate(t);
  });

  /* keyboard: the thumbs are role="button" tabindex="0" spans inside the card <a>,
     so Enter/Space must route to the variant deep-link (and preview on focus) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target.closest('[data-cardsw-thumb]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    activate(t);
  });

  document.addEventListener('focusin', function (e) {
    var t = e.target.closest('[data-cardsw-thumb]');
    if (t) preview(t);
  });

  document.addEventListener('focusout', function (e) {
    var t = e.target.closest('[data-cardsw-thumb]');
    if (!t) return;
    var grp = t.closest('[data-cardsw]');
    var to = e.relatedTarget;
    if (!to || !grp || !grp.contains(to)) restore(grp);
  });
})();
